import { Box, Button, Modal, Stack, Typography, useTheme } from '@mui/material'
import React from 'react';
import { useQueryClient } from 'react-query';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import { sendAckServ } from '../../../services/source-service';
import { useState } from 'react';
import MailsTxtField from '../../../components/MailsTxtField';
import CtrlLabelTxtFieldInfo from '../../../components/CtrlLabelTxtFieldInfo';

function SendAckMdl({ modalOpen, handleModalClose, poData }) {
    const [formErrors, setFormErrors] = useState({});
    const { setLoadingScreen } = useAuthContext();
    const queryClient = useQueryClient();
    const theme = useTheme();
    const [emails, setEmails] = useState([]);
    const [selection, setSelection] = useState({ content: "" })


    useState(() => {
        if (!poData)
            return

        setSelection((e) => { return { ...e, content: poData?.ackTemp ?? "" } });

        if (!poData?.mailToArr)
            return
        const arr = (poData?.mailToArr || []).map((i) => i?.username);
        setEmails([...arr])
    }, [poData])



    async function handleSubmit(e) {
        e.preventDefault();
        if (emails.length === 0) {
            notify("error", "At least one email should be entered!");
            return
        }
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); 
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;
        setLoadingScreen(true);
        try {
            const payload = {
                poIdStrg: poData?.poIdStrg,
                toMail: emails.join(', '),
                content: inputObject?.content
            }
            const { message } = await sendAckServ(payload);
            notify("success", message);
            handleModalClose();
            queryClient.invalidateQueries();
        } catch (err) {
            console.log(err);
            customAlert(err);
        }
        setLoadingScreen(false);
    }

    function validate(values) {
        const errors = {};

        if (!values.content)
            errors.content = "Description is required!";

        return errors;
    };

    function handleValChange(e) {
        const { name, value } = e.target;
        setSelection((e) => { return { ...e, [name]: value } });
    }



    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {poData ? <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} justifyContent={"center"} mb={2} width={"100%"}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>Send Acknowledgment</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">
                        <MailsTxtField emails={emails} setEmails={setEmails} width={"100%"} title={"To"} />

                        <CtrlLabelTxtFieldInfo value={selection.content} onChange={handleValChange} name="content" errMsg={formErrors?.content} title="Description *" width={"100%"} borderRadius={1}
                            rows={12} multiline={true} height={210} />
                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 1 }} width={"100%"} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}>  CANCEL</Button>
                            <Button variant="contained" type='submit'
                                sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}>
                                SEND</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>
            }
        </Modal>
    )
}

export default SendAckMdl;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "60vw",
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 2,
    borderRadius: 2,
};


